import { render, staticRenderFns } from "./CommCallModal.vue?vue&type=template&id=a2c55482&scoped=true&"
import script from "./CommCallModal.vue?vue&type=script&lang=js&"
export * from "./CommCallModal.vue?vue&type=script&lang=js&"
import style0 from "./CommCallModal.vue?vue&type=style&index=0&id=a2c55482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c55482",
  null
  
)

export default component.exports